import dynamic from 'next/dynamic';
import { Box } from '@chakra-ui/react';
import { AssociationPage as Props } from '../../types';
import { resolveFields, hasForestExpertField } from '../Fields';
import ArticleContainer from '../ArticleContainer';
import Breadcrumb from '../Breadcrumb';
import HeroSplit from '../HeroSplit';
import { ContentColumn as Column, ContentColumns } from '../BasicBlocks';
import { splitFields } from './Page';
import Buttons from '../Buttons';
import { BlocksProvider } from '../../lib/blocks.context';
import { BlockRenderer } from '../Fields/BlockRenderer';

const Map = dynamic(() => import('../Map'));
const OfficeTeaser = dynamic(() => import('../OfficeTeaser'));

const defaultHeroButtons = [
  { link: { title: 'Löydä oma metsäasiantuntijasi', url: '#forest-expert' } },
];

const AssociationPage = ({
  fields,
  post_title: title,
  post_excerpt: leadText,
  featured_image: image,
  data: { office, location },
}: Props) => {
  const [hero, contentFields] = resolveFields(fields);
  const basicFieldKeys = [
    'core/paragraph',
    'core/heading',
    'core/list',
    'core/quote',
    'core/block',
    'core/media-text',
    'video',
    'accordion',
    'membership-fee',
    'board-members',
    'buttons',
  ];
  const { basicFields, sectionFields } = splitFields(
    contentFields,
    basicFieldKeys,
  );

  const renderDefaultButtons = hasForestExpertField(sectionFields);

  const { heroButtons, ...heroProps } = hero
    ? {
        title: hero.heading?.title || title,
        leadText: hero.text || leadText,
        image: hero.image || image,
        heroButtons:
          hero.buttons || (renderDefaultButtons ? defaultHeroButtons : null),
      }
    : {
        title,
        leadText,
        image,
        heroButtons: renderDefaultButtons ? defaultHeroButtons : null,
      };

  return (
    <ArticleContainer>
      <Box>
        <Breadcrumb mb="4" />
        <HeroSplit {...heroProps}>
          {heroButtons && <Buttons buttons={heroButtons} size="xl" />}
        </HeroSplit>
      </Box>
      <ContentColumns>
        <Column>
          <Box>
            <BlocksProvider value={{ layoutType: 'basic' }}>
              <BlockRenderer blocks={basicFields} />
            </BlocksProvider>
          </Box>
        </Column>
        <Column>
          {office ? <OfficeTeaser {...office} /> : null}
          {location ? <Map {...location} height="343" /> : null}
        </Column>
      </ContentColumns>
      <BlocksProvider value={{ layoutType: 'section' }}>
        <BlockRenderer blocks={sectionFields} />
      </BlocksProvider>
    </ArticleContainer>
  );
};

export default AssociationPage;
